/* const createKeywords = (name) => {
  const arrName = [];
  let curName = "";
  name
    .toLowerCase()
    .split("")
    .forEach((word) => {
      word.split("").forEach((letter) => {
        curName += letter;
        arrName.push(curName);
      });
    });
  return arrName;
}; */

const createKeywords = (countryName) => {
    const wordArr = countryName.toLowerCase().split(' ');
    const searchableKeywords = [];
    let prevKey = '';
    for (const word of wordArr) {
      const charArr = word.toLowerCase().split('');
      for (const char of charArr) {
        const keyword = prevKey + char;
        searchableKeywords.push(keyword);
        prevKey = keyword;
      }
      prevKey = '';
    }
    return searchableKeywords;
  };

export { createKeywords };
